import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { updateUser } from "../../../redux/auth/authSlice";
import { useTranslation } from "react-i18next";
import { LOCALES } from "common/constants";

const Redirect = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("i18nextLng", searchParams.get("lang"));
  let language = localStorage.getItem("i18nextLng");
  const { t } = useTranslation();

  useEffect(() => {
    const loginAndFetchUser = async () => {
      try {
        setLoading(true);
        if (
          searchParams.get("token") === "" &&
          searchParams.get("userId") === "" &&
          searchParams.get("email") === "" &&
          searchParams.get("message")
        ) {
          toast.error(t(searchParams.get("message")));
          navigate(language === LOCALES.EN_US ? `/login?lang=${LOCALES.EN_US}`: `/logga-in?lang=${LOCALES.SV_SE}`);
        } else if (
          searchParams.get("token") &&
          searchParams.get("userId") &&
          searchParams.get("email") &&
          searchParams.get("expireIn") &&
          searchParams.get("message")
        ) {
          const user = {
            expireIn: searchParams.get("expireIn"),
            token: searchParams.get("token"),
          };
          const logged = searchParams.get("IsLoginWithBankId");
          localStorage.setItem("user", JSON.stringify(user));

          const res = await axios.get(
            `/employee/get/${searchParams.get("userId")}`
          );

          dispatch(updateUser(res.data.response));
          user.userData = res.data.response;
          if (user?.userData) {
            localStorage.setItem("user", JSON.stringify(user));
          }
          if (logged) {
            document.cookie = `logged=1; path=/`;
          }
          setSearchParams(
            {},
            {
              replace: true,
            }
          );
          toast.success(searchParams.get("message"));
        }
      } catch (error) {
        const message =
          (error?.response &&
            error?.response?.data &&
            error?.response?.data?.message) ||
          error?.message ||
          error.toString();
        toast.error(t(message));
      } finally {
        setLoading(false);
      }
    };
    loginAndFetchUser();
  }, [searchParams, setSearchParams, dispatch, language, navigate, t]);

  return (
    <>
      {loading && <Loader />}
      {searchParams.get("token") === "" &&
        navigate(
          language === LOCALES.EN_US
            ? `/login?message=${searchParams.get(
                "message"
              )}&email=${searchParams.get("email")}&lang=${LOCALES.EN_US}`
            : `/logga-in/?message=${searchParams.get(
                "message"
              )}&email=${searchParams.get("email")}&lang=${LOCALES.SV_SE}`
        )}
    </>
  );
};

export default Redirect;
